import { useRef, useState } from "react";

export default function MentionTextarea({ value, onChange, users = [], placeholder, testid, rows = 2, autoFocus = false }) {
  const [query, setQuery] = useState(null);
  const ref = useRef();

  const handleChange = (e) => {
    const v = e.target.value;
    onChange(v);
    const caret = e.target.selectionStart;
    const before = v.slice(0, caret);
    const m = before.match(/@([\w]*)$/);
    setQuery(m ? m[1].toLowerCase() : null);
  };

  const pick = (u) => {
    const el = ref.current;
    const caret = el.selectionStart;
    const before = value.slice(0, caret).replace(/@([\w]*)$/, `@${u.name} `);
    const after = value.slice(caret);
    const nv = before + after;
    onChange(nv);
    setQuery(null);
    setTimeout(() => { el.focus(); el.setSelectionRange(before.length, before.length); }, 0);
  };

  const matches = query === null ? [] : users.filter((u) => (u.name || "").toLowerCase().includes(query)).slice(0, 6);

  return (
    <div className="relative flex-1">
      <textarea
        ref={ref}
        data-testid={testid}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        autoFocus={autoFocus}
        className="w-full resize-none border border-zinc-200 px-2 py-1.5 text-sm outline-none focus:border-[#e84e34]"
      />
      {query !== null && matches.length > 0 && (
        <div className="absolute bottom-full left-0 z-50 mb-1 w-56 border border-zinc-200 bg-white shadow-lg" data-testid="mention-dropdown">
          {matches.map((u) => (
            <button key={u.id} type="button" onClick={() => pick(u)} data-testid={`mention-option-${u.id}`} className="flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm hover:bg-zinc-50">
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#e84e34] text-[10px] font-bold text-white">{(u.name || "?")[0]}</span>
              {u.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
